export const questions = [
  {
    id: 'domain',
    text: 'What is your company\'s domain name or website?',
    description: `Please provide your company's website URL (e.g., example.com) or main domain name. 
    This will help us automatically analyze your company's profile and suggest answers for the following questions.`,
    type: 'text',
    autoAnalyze: true
  },
  {
    id: 'size',
    text: 'What is the size of your company?',
    description: `The size of your company is determined by both employee count and financial metrics:
    
    • Small: Less than 50 employees AND annual turnover/balance sheet ≤ €10M
    • Medium: 50-249 employees OR annual turnover ≤ €50M/balance sheet ≤ €43M
    • Large: 250+ employees OR annual turnover > €50M/balance sheet > €43M
    
    Note: For groups of companies, consider the consolidated numbers.`,
    options: [
      { value: 'small', label: 'Small (< 50 employees & annual turnover ≤ €10M)' },
      { value: 'medium', label: 'Medium (50-249 employees OR turnover ≤ €50M)' },
      { value: 'large', label: 'Large (≥ 250 employees OR turnover > €50M)' }
    ],
    autoAnalyze: true
  },
  {
    id: 'sector',
    text: 'Which sector does your company operate in?',
    description: `NIS2 applies to specific sectors considered essential for the EU economy:`,
    options: [
      // Energy sector
      { value: 'energy_electricity', label: 'Energy - Electricity' },
      { value: 'energy_oil', label: 'Energy - Oil' },
      { value: 'energy_gas', label: 'Energy - Gas' },
      { value: 'energy_hydrogen', label: 'Energy - Hydrogen' },
      // Transport
      { value: 'transport_air', label: 'Transport - Air' },
      { value: 'transport_rail', label: 'Transport - Rail' },
      { value: 'transport_water', label: 'Transport - Water' },
      { value: 'transport_road', label: 'Transport - Road' },
      // Banking and Financial
      { value: 'banking', label: 'Banking' },
      { value: 'financial_market', label: 'Financial Market Infrastructure' },
      { value: 'insurance', label: 'Insurance' },
      // Healthcare
      { value: 'healthcare_providers', label: 'Healthcare Providers' },
      { value: 'pharma', label: 'Pharmaceutical' },
      { value: 'medical_devices', label: 'Medical Devices' },
      // Digital Infrastructure
      { value: 'digital_infrastructure', label: 'Digital Infrastructure (DNS, TLD, etc.)' },
      { value: 'cloud_services', label: 'Cloud Computing Services' },
      { value: 'data_center', label: 'Data Center Services' },
      { value: 'cdn', label: 'Content Delivery Networks' },
      // Public Administration
      { value: 'public_admin', label: 'Public Administration' },
      { value: 'space', label: 'Space' },
      // Utilities
      { value: 'water', label: 'Drinking Water Supply and Distribution' },
      { value: 'wastewater', label: 'Wastewater' },
      // ICT Service Management
      { value: 'ict_services', label: 'ICT Service Management (B2B)' },
      // Manufacturing
      { value: 'manufacturing_critical', label: 'Manufacturing of Critical Products' },
      // Postal and Courier
      { value: 'postal', label: 'Postal and Courier Services' },
      // Waste Management
      { value: 'waste', label: 'Waste Management' },
      // Chemical
      { value: 'chemical', label: 'Chemical Industry' },
      // Food
      { value: 'food', label: 'Food Production and Distribution' },
      // Digital Providers
      { value: 'online_marketplace', label: 'Online Marketplace' },
      { value: 'search_engine', label: 'Online Search Engine' },
      { value: 'social_network', label: 'Social Networking Platform' },
      // Other
      { value: 'other', label: 'Other' }
    ],
    autoAnalyze: true
  },
  {
    id: 'critical',
    text: 'Does your company provide services essential for maintaining critical societal or economic activities?',
    description: `Consider if your services are crucial for maintaining critical functions in society. Examples include:

    • Services that other essential entities depend on
    • Services that would cause significant public safety risks if disrupted
    • Services that are critical for economic stability
    
    Examples:
    • A software provider serving multiple hospitals
    • A payment processor handling government transactions
    • A cloud provider hosting critical infrastructure services`,
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'unsure', label: 'Unsure' },
      { value: 'no', label: 'No' }
    ],
    autoAnalyze: true
  },
  {
    id: 'disruption',
    text: 'Would a cybersecurity incident in your company have significant disruptive effects on service provision?',
    description: `Consider the potential impact of a major cybersecurity incident on your services. Significant disruption might include:

    • Service unavailability affecting over 100,000 users
    • Disruption of critical services for more than 24 hours
    • Impact on public safety or national security
    • Substantial economic losses for third parties
    
    Example scenarios:
    • A cloud service outage affecting multiple business customers
    • A banking system failure preventing transactions
    • A healthcare system breach affecting patient care`,
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'unsure', label: 'Unsure' },
      { value: 'no', label: 'No' }
    ],
    autoAnalyze: true
  }
];